import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { closeModal } from '@/helpers/closeModal';
import { commonChangeMediaProcess, isMediaImageReady, setImageTimer, clearImageTimer } from '@/helpers/mediaUtils';
import { updateCtaButtonAction } from '@/modules/actions/mobile/updateCtaButtonAction';
import { animateCurrentProgressBar, animateCurrentProgressBarInElement, prepareCurrentProgressBar, prepareCurrentProgressBarInElement } from '@/modules/actions/headerLineDuration';
import { showMediaLoadingShimmer, hideMediaLoadingShimmer } from '@/helpers/mediaLoadingShimmer';
import { getSwiperInstance } from '@/helpers/swiperInstance';
import { queryHeaderElement } from '@/helpers/headerShadow';
import { checkVolumeButtonState } from '@/helpers/volumeControl';
import {
  maybeShowTargetingQuestionnaireForCurrentContent,
  maybeShowTargetingQuestionnaireForNextContent,
} from '@/helpers/maybeShowTargetingQuestionnaire';
import { isReelLike } from '@/helpers/isReelLike';

let previousMovie = null;

export const mobileAutoPlayNextAction = () => {
  let movie;
  if  (window.storeeelItems.frame === "circle") {
    movie = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .storeeel-movie.active');
  } else {
    movie = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper .storeeel-movie');
  }

  if (movie) {
    // 前の動画のイベントを解除
    if (previousMovie && previousMovie._endedListener) {
      previousMovie.removeEventListener("ended", previousMovie._endedListener);
      delete previousMovie._endedListener;
    }

    // 新しい動画にイベントを追加
    const onEnded = () => {
      // 超高速スワイプ等で「非アクティブスライドの動画」の ended が遅れて発火すると、
      // 意図せず自動送りが走って巻き戻るように見えることがあるため、アクティブ以外は無視する。
      const activeMovie = window.storeeelItems.frame === "circle"
        ? document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .storeeel-movie.active')
        : document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper .storeeel-movie');
      if (movie !== activeMovie) return;
      commponProcess();
    };

    movie.addEventListener("ended", onEnded);
    movie._endedListener = onEnded;
    previousMovie = movie;
  }

  // 画像の自動再生
  mobileAutoPlayNextImageAction();
};

export const mobileAutoPlayNextImageAction = () => {
  let image;
  if (window.storeeelItems.frame === "circle") {
    image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper .storeeel-media-image.active');
  } else {
    image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper .storeeel-media-image');
  }
  if (image) {
    let hasTriggered = false;
    const isTrackedImageActive = () => {
      const activeSlide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
      return !!activeSlide && activeSlide.contains(image);
    };

    const triggerNext = () => {
      if (hasTriggered) {
        return;
      }
      hasTriggered = true;
      clearImageTimer();
      commponProcess();
    };

    if (image._onLoadForAutoPlay) {
      image.removeEventListener('load', image._onLoadForAutoPlay);
      image._onLoadForAutoPlay = null;
    }
    if (image._onErrorForAutoPlay) {
      image.removeEventListener('error', image._onErrorForAutoPlay);
      image._onErrorForAutoPlay = null;
    }

    // 直前までに登録された animationend リスナーを必ず解除する。
    // mobileAutoPlayNextImageAction は transitionEnd / ensure / 自動送り完了などから複数回呼ばれるため、
    // 解除しないと同一バーに animationend リスナーが多重登録され、アニメーション完了時に
    // commponProcess が複数回走って「一気に先のコンテンツへスキップ」してしまう（画像で発生。
    // 動画は previousMovie による ended の付け替えで多重登録されないため起きない）。
    if (image._onAnimationEndForAutoPlay && image._animationEndBannerForAutoPlay) {
      try {
        image._animationEndBannerForAutoPlay.removeEventListener('animationend', image._onAnimationEndForAutoPlay);
      } catch { void 0; }
    }
    image._onAnimationEndForAutoPlay = null;
    image._animationEndBannerForAutoPlay = null;

    const cleanup = () => {
      if (image._onLoadForAutoPlay) {
        image.removeEventListener('load', image._onLoadForAutoPlay);
        image._onLoadForAutoPlay = null;
      }
      if (image._onErrorForAutoPlay) {
        image.removeEventListener('error', image._onErrorForAutoPlay);
        image._onErrorForAutoPlay = null;
      }
    };

    const startTimer = () => {
      if (!isTrackedImageActive()) {
        cleanup();
        return;
      }
      setImageTimer(() => {
        if (!isTrackedImageActive()) {
          return;
        }
        triggerNext();
      }, 5000);

      const activeSlide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
      const activeBanner = activeSlide
        ? queryHeaderElement('.storeeel-movie-select_banner.active', activeSlide)
        : null;
      if (activeBanner) {
        const handleAnimationEnd = () => {
          if (!isTrackedImageActive()) {
            return;
          }
          triggerNext();
        };
        // 多重登録防止のため、保持中の animationend リスナーがあれば解除してから付け替える
        if (image._onAnimationEndForAutoPlay && image._animationEndBannerForAutoPlay) {
          try {
            image._animationEndBannerForAutoPlay.removeEventListener('animationend', image._onAnimationEndForAutoPlay);
          } catch { void 0; }
        }
        image._onAnimationEndForAutoPlay = handleAnimationEnd;
        image._animationEndBannerForAutoPlay = activeBanner;
        activeBanner.addEventListener('animationend', handleAnimationEnd, { once: true });
      }
      cleanup();
    };

    const tryStartTimer = () => {
      if (!isTrackedImageActive()) {
        cleanup();
        return false;
      }
      if (!isMediaImageReady(image)) return false;
      startTimer();
      return true;
    };

    // 画像の読み込み完了後にタイマー開始
    image._onLoadForAutoPlay = () => { tryStartTimer(); };
    image._onErrorForAutoPlay = () => { cleanup(); };
    image.addEventListener('load', image._onLoadForAutoPlay);
    image.addEventListener('error', image._onErrorForAutoPlay);
    tryStartTimer();
  }
}

function commponProcess() {
  const swiper = getSwiperInstance();
  const isMobileSquare = Boolean(window.storeeelItems?.isMobile) && isReelLike(window.storeeelItems?.frame);
  const isMobileCircle = Boolean(window.storeeelItems?.isMobile) && window.storeeelItems?.frame === 'circle';

  if (isMobileCircle && maybeShowTargetingQuestionnaireForNextContent({
    onContinueWithoutAnswers: () => {
      commponProcess();
    },
  })) {
    return;
  }

  const prevIconId = window.iconId;
  const prevMoviePosition = window.moviePosition;

  // 次の動画を再生
  window.moviePosition += 1;
  const contents = navigateMediaItem();
  if (!contents) {
    return closeModal();
  }

  const normalizeGroupId = (value) => (value == null ? '' : String(value).split('-').pop());
  const prevGroupId = normalizeGroupId(prevIconId);
  const nextGroupId = normalizeGroupId(window.iconId);
  const didGroupChange = prevGroupId && nextGroupId ? prevGroupId !== nextGroupId : true;
  // 末尾→先頭のグループ遷移時のみスライド移動（単一グループのループは通常更新）
  const shouldHandleGroupTransition = window.moviePosition === 0 && didGroupChange;

  if (!shouldHandleGroupTransition) {
    window._storeeelPendingGroupSlideIndex = null;
    commonChangeMediaProcess(contents);
    // 自動送りで同グループの次コンテンツに切り替わった際、バッファ動画は
    // 常にミュート状態で生成されるため、タップ遷移と同様にユーザーの
    // 音量ボタンの状態（ミュート/解除）を反映する。
    checkVolumeButtonState();
  } else {
    const nextIconId = window.iconId;
    const pendingIdx = Number.isFinite(window._storeeelPendingGroupSlideIndex)
      ? window._storeeelPendingGroupSlideIndex
      : null;
    window._storeeelPendingGroupSlideIndex = null;

    if (isMobileSquare) {
      const groups = window.storeeelItems?.contentGroups || [];
      const groupsLen = groups.length;
      const currentRealIndex = Number.isFinite(swiper?.realIndex) ? swiper.realIndex : (swiper?.activeIndex ?? 0);
      const targetRealIndex = pendingIdx != null
        ? pendingIdx
        : (groupsLen > 0 ? ((currentRealIndex + 1) % groupsLen) : null);

      // 遷移中にさらに自動送りが来た場合は後続で再実行
      if (swiper?.animating) {
        window._storeeelSquarePendingAutoPlay = true;
        window.iconId = prevIconId;
        window.moviePosition = prevMoviePosition;
        const retryDelay = typeof swiper?.params?.speed === 'number' ? swiper.params.speed + 50 : 550;
        window.setTimeout(() => {
          if (window._storeeelSquarePendingAutoPlay) {
            window._storeeelSquarePendingAutoPlay = false;
            mobileAutoPlayNextAction();
          }
        }, retryDelay);
        return;
      }
      window._storeeelSquarePendingAutoPlay = false;
      if (window._storeeelSquareAutoAdvanceInProgress) {
        window._storeeelSquarePendingAutoPlay = true;
        window.iconId = prevIconId;
        window.moviePosition = prevMoviePosition;
        return;
      }
      if (targetRealIndex == null) return;

      window._storeeelSquareTargetRealIndex = targetRealIndex;
      const nextGroupId = nextIconId ?? groups?.[targetRealIndex]?.id;
      window._storeeelSquarePendingPositionUpdate = { iconId: nextGroupId, moviePosition: 0 };
      window.iconId = prevIconId;
      window.moviePosition = prevMoviePosition;
      window._storeeelSquareAutoAdvanceInProgress = true;
      // 稀に transitionEnd が取れず _storeeelSquareAutoAdvanceInProgress が解除されないケースがあるため、
      // ウォッチドッグで自動解除してデッドロックを防ぐ（通常は groupSwipeAction 側で解除される）。
      if (window._storeeelSquareAutoAdvanceGuardTimer) {
        clearTimeout(window._storeeelSquareAutoAdvanceGuardTimer);
      }
      const guardDelay = typeof swiper?.params?.speed === 'number' ? swiper.params.speed + 1500 : 2000;
      window._storeeelSquareAutoAdvanceGuardTimer = window.setTimeout(() => {
        window._storeeelSquareAutoAdvanceInProgress = false;
        // transitionEnd 系イベントを取りこぼした場合でも、次の自動送り用 ended リスナーは復元しておく
        mobileAutoPlayNextAction();
      }, guardDelay);

      const isLoop = Boolean(swiper?.params?.loop);
      const loopedSlides = Number.isFinite(swiper?.loopedSlides) ? swiper.loopedSlides : null;
      const slidesLen = Array.isArray(swiper?.slides) ? swiper.slides.length : null;
      const activeIndex = Number.isFinite(swiper?.activeIndex) ? swiper.activeIndex : null;
      // loop（複製スライド）環境で、active が端（clone領域）にいる時に slideToLoop を使うと
      // 「最短経路」で逆方向に動くことがあり、巻き戻りのように見えるため slideNext を優先する。
      const isLoopEdge =
        isLoop
        && loopedSlides != null
        && slidesLen != null
        && activeIndex != null
        && (activeIndex < loopedSlides || activeIndex >= slidesLen - loopedSlides);

      const shouldPreferSlideNext =
        typeof swiper?.slideNext === 'function'
        && isLoop
        && groupsLen > 0
        && Number.isFinite(currentRealIndex)
        && Number.isFinite(targetRealIndex)
        // 2件 loop では slideNext が末尾→先頭で不安定になりやすいため、
        // 実インデックスを明示できる slideToLoop 系を優先する。
        && groupsLen > 2
        && ((currentRealIndex + 1) % groupsLen) === targetRealIndex
        && (
          // 末尾→先頭ループ時だけ「最短経路で逆方向へ動く」見えを避ける
          (currentRealIndex === groupsLen - 1 && targetRealIndex === 0)
          // clone領域にいる場合も逆方向になり得るため、スワイプと同じ slideNext に揃える
          || isLoopEdge
        );

      if (shouldPreferSlideNext) {
        swiper.slideNext();
      } else if (pendingIdx != null && typeof swiper?.slideToLoop === 'function') {
        swiper.slideToLoop(pendingIdx);
      } else if (pendingIdx != null && typeof swiper?.slideTo === 'function') {
        swiper.slideTo(pendingIdx);
      } else if (typeof swiper?.slideToLoop === 'function') {
        swiper.slideToLoop(targetRealIndex);
      } else if (typeof swiper?.slideTo === 'function') {
        swiper.slideTo(targetRealIndex);
      }
      // 稀にスライド移動が反映されず realIndex が進まないケースのフォールバック
      if (window._storeeelSquareAutoAdvanceTimer) {
        clearTimeout(window._storeeelSquareAutoAdvanceTimer);
      }
      const fallbackDelay = typeof swiper?.params?.speed === 'number' ? swiper.params.speed + 50 : 550;
      const currentIndexBefore = Number.isFinite(swiper?.realIndex) ? swiper.realIndex : (swiper?.activeIndex ?? null);
      window._storeeelSquareAutoAdvanceTimer = window.setTimeout(() => {
        const s = getSwiperInstance();
        const currentIndexAfter = Number.isFinite(s?.realIndex) ? s.realIndex : (s?.activeIndex ?? null);
        if (s && currentIndexAfter === currentIndexBefore) {
          if (typeof s.slideToLoop === 'function') {
            s.slideToLoop(targetRealIndex, 0);
          } else if (typeof s.slideTo === 'function') {
            s.slideTo(targetRealIndex, 0);
          }
        }
      }, fallbackDelay);
      // 再生・進捗・CTA更新は transitionEnd 側で実スライドに対して行う
      return;
    }

    const isCircle = window.storeeelItems?.frame === 'circle';
    const shouldPreferSlideNext = isCircle && Boolean(swiper?.params?.loop) && typeof swiper?.slideNext === 'function';
    // モバイル + ストーリー型(loop)の自動送りはタップと同じ「次へ」遷移に揃える
    if (shouldPreferSlideNext) {
      swiper.slideNext();
    } else if (pendingIdx != null && typeof swiper?.slideToLoop === 'function') {
      swiper.slideToLoop(pendingIdx);
    } else if (pendingIdx != null && typeof swiper?.slideTo === 'function') {
      swiper.slideTo(pendingIdx);
    } else {
      swiper.slideNext();
    }
  }

  // 進捗バーのためのインデックスを計算
  let groupIndex = window.storeeelItems.contentGroups.findIndex(group => group.id === window.iconId);
  let progressIndex = 0;
  if (window.storeeelItems.frame === "circle") {
    progressIndex = window.moviePosition;
  } else if (isReelLike(window.storeeelItems.frame)) {
    // リール型・タイル型は「1グループ=1コンテンツ」想定のため常に0
    progressIndex = 0;
  } else if (groupIndex == 0) {
    progressIndex = window.moviePosition;
  } else {
    for (let i = 0; i < groupIndex; i++) {
      progressIndex += window.storeeelItems.contentGroups[i].contents.length;
    }
    progressIndex += window.moviePosition;
  }
  // 進捗バーのアニメーションを開始
  const activeSlide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
  const activeWrapper = activeSlide?.querySelector('.slide-media-wrapper');
  showMediaLoadingShimmer(activeWrapper);
  const useElementProgress = (window.storeeelItems.frame === "circle" || isReelLike(window.storeeelItems.frame)) && activeSlide;
  const prepareProgress = () => {
    if (useElementProgress) {
      prepareCurrentProgressBarInElement(progressIndex, activeSlide);
    } else {
      prepareCurrentProgressBar(progressIndex);
    }
  };

  const video = document.querySelector('.storeeel-swiper-group-wrapper  .swiper-slide-active .slide-media-wrapper video.storeeel-movie');
  if (video && video.style.display !== 'none') {
    // 既存ハンドラが残ると複数回実行されるため解除してから登録し直す
    if (video._onLoadedMetadataForProgress) {
      video.removeEventListener('loadedmetadata', video._onLoadedMetadataForProgress);
      video._onLoadedMetadataForProgress = null;
    }
    if (video._onCanPlayForProgress) {
      video.removeEventListener('canplay', video._onCanPlayForProgress);
      video._onCanPlayForProgress = null;
    }
    if (video._onPlayingForProgress) {
      video.removeEventListener('playing', video._onPlayingForProgress);
      video._onPlayingForProgress = null;
    }

    const cleanup = () => {
      if (video._onLoadedMetadataForProgress) {
        video.removeEventListener('loadedmetadata', video._onLoadedMetadataForProgress);
        video._onLoadedMetadataForProgress = null;
      }
      if (video._onCanPlayForProgress) {
        video.removeEventListener('canplay', video._onCanPlayForProgress);
        video._onCanPlayForProgress = null;
      }
      if (video._onPlayingForProgress) {
        video.removeEventListener('playing', video._onPlayingForProgress);
        video._onPlayingForProgress = null;
      }
    };

    const startProgress = (duration) => {
      if (useElementProgress) {
        animateCurrentProgressBarInElement(duration, progressIndex, activeSlide);
      } else {
        animateCurrentProgressBar(duration, progressIndex);
      }
      hideMediaLoadingShimmer(activeWrapper);
    };

    const tryStartProgress = () => {
      const slide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
      if (!slide || slide !== activeSlide || !slide.contains(video)) {
        cleanup();
        hideMediaLoadingShimmer(activeWrapper);
        return false;
      }
      if (video.paused || video.ended) return false;
      if (video.readyState < 2) return false;
      const duration = Number(video.duration);
      if (!Number.isFinite(duration) || duration <= 0) return false;
      startProgress(duration);
      return true;
    };

    const onReady = () => {
      if (tryStartProgress()) {
        cleanup();
      }
    };

    // 再生開始まで進捗を開始しない
    prepareProgress();
    video._onLoadedMetadataForProgress = onReady;
    video._onPlayingForProgress = onReady;
    video.addEventListener('loadedmetadata', onReady);
    video.addEventListener('playing', onReady);
    onReady();
  } else {
    const image = document.querySelector('.storeeel-swiper-group-wrapper  .swiper-slide-active .slide-media-wrapper img.storeeel-media-image');
    if (image) {
      if (image._onLoadForProgress) {
        image.removeEventListener('load', image._onLoadForProgress);
        image._onLoadForProgress = null;
      }
      if (image._onErrorForProgress) {
        image.removeEventListener('error', image._onErrorForProgress);
        image._onErrorForProgress = null;
      }

      const cleanup = () => {
        if (image._onLoadForProgress) {
          image.removeEventListener('load', image._onLoadForProgress);
          image._onLoadForProgress = null;
        }
        if (image._onErrorForProgress) {
          image.removeEventListener('error', image._onErrorForProgress);
          image._onErrorForProgress = null;
        }
      };

      const startProgress = () => {
        const slide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
        if (!slide || slide !== activeSlide || !slide.contains(image)) {
          cleanup();
          hideMediaLoadingShimmer(activeWrapper);
          return;
        }
        if (useElementProgress) {
          animateCurrentProgressBarInElement(5, progressIndex, activeSlide);
        } else {
          animateCurrentProgressBar(5, progressIndex);
        }
        hideMediaLoadingShimmer(activeWrapper);
        cleanup();
      };

      const tryStartProgress = () => {
        const slide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
        if (!slide || slide !== activeSlide || !slide.contains(image)) {
          cleanup();
          hideMediaLoadingShimmer(activeWrapper);
          return false;
        }
        if (!isMediaImageReady(image)) return false;
        startProgress();
        return true;
      };

      // 読み込み完了後に進捗を開始する
      prepareProgress();
      image._onLoadForProgress = () => { tryStartProgress(); };
      image._onErrorForProgress = () => { cleanup(); };
      image.addEventListener('load', image._onLoadForProgress);
      image.addEventListener('error', image._onErrorForProgress);
      tryStartProgress();
    }
  }

  const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper  .swiper-slide');
  const currentSlide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active') || allSlides[swiper.activeIndex];
  const slideMediaWrapper = currentSlide.querySelector('.slide-media-wrapper');
  // CTAボタンの更新
  updateCtaButtonAction(slideMediaWrapper)
  if (maybeShowTargetingQuestionnaireForCurrentContent()) return;

  // 自動再生の設定
  mobileAutoPlayNextAction();
}
